import React from 'react'

interface SocialLoginUser {
    // Define the user object structure based on your application needs
    // This is a placeholder - adjust properties as needed
    [key: string]: any
}

interface SocialLoginContextType {
    socialLogin: { user: SocialLoginUser | null }
    setSocialLoginUser: (user: SocialLoginUser | null) => void
    clearSocialLoginUser: () => void
}

const internalContext = React.createContext<SocialLoginContextType>({
    socialLogin: { user: null },
    setSocialLoginUser: (): void => { },
    clearSocialLoginUser: (): void => { }
})

internalContext.displayName = "SecurSpaceSocialLoginContext"

export const SocialLoginContext = internalContext
